import { render, staticRenderFns } from "./profitCode.vue?vue&type=template&id=5efc9c8c&scoped=true"
import script from "./profitCode.vue?vue&type=script&lang=js"
export * from "./profitCode.vue?vue&type=script&lang=js"
import style0 from "./profitCode.vue?vue&type=style&index=0&id=5efc9c8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_3rwm2qttujvjuolkwtduiruple/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efc9c8c",
  null
  
)

export default component.exports